<template>
  <el-card shadow="never" class="activeResult-card echarts-box">
    <h4>活动效果</h4>
    <div v-if="activeTrend && activeTrend.length" id="activeResult"></div>
    <NoData v-else errTitle="暂无数据" setHeight="250px"></NoData>
  </el-card>
</template>
<script>
import echarts from 'echarts'
import NoData from "@/components/base/no-data"
import { getActiveResult } from '@/api/marketPromotion/activeData'
import { yuanUnit } from '../config'
export default {
  components: {NoData},
  props: {
    baseData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      activeTrend:[],
      echartsDom: null
    }
  },
  methods: {
    init () {
      let params = Object.assign({}, this.baseData)
      this.getActiveResult(params)
    },
    drawLine (data) {
      if (!data || !data.length) return
      this.echartsDom = null
      this.echartsDom = echarts.init(document.getElementById('activeResult'))
      // 处理X轴
      let xLabel = data.map(item => item.dateTime.split(' ')[1])
      // 处理数据
      let activityAmount = data.map(item => item.activityAmount)
      let disActivityAmount = data.map(item => item.disActivityAmount)
      this.echartsDom.setOption({
        color: ['#3377FF', '#FFAC52', '#ADCD40'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          axisPointer: {
            type: 'line',
            lineStyle: {
              type: 'dashed'
            },
            label: {
              backgroundColor: '#6a7985'
            }
          },
          textStyle: {
            color: '#606266'
          },
          formatter: (param) => {
            let html = `
              <p style="margin:5px 0"><b>${data[param[0].dataIndex].dateTime}</b></p>
            `
            param.forEach(item => {
              html += `
                <span style="display:inline-block;width:10px;height:10px;border-radius:5px;border:2px ${item.color} solid ;margin-right:5px"></span>
                <span>${item.seriesName}：${yuanUnit(item.data)}元</span></br>
              `
            })
            return html
          },
          padding: [10,16],
          extraCssText: 'box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1)'
        },
        xAxis: {
          type: 'category',
          data: xLabel,
          nameTextStyle: {
            color:'#666'
          },
          axisLine: {
            lineStyle: {
              color:'#EAEAEA'
            }
          },
          axisLabel: {
            color:'#666'
          },
          axisTick: {
            show: false
          }
        },
        legend: {
          data: ['活动销售收入', '非活动销售收入'],
          right: '4%',
          itemHeight: 2
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              type:'dashed',
              color:'#EAEAEA'
            }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name:'活动销售收入',
            data: activityAmount,
            type: 'bar',
            barMaxWidth: '40',
            stack: 'total'
          },
          {
            name:'非活动销售收入',
            data: disActivityAmount,
            type: 'bar',
            barMaxWidth: '40',
            stack: 'total'
          }
        ]
      })
    },
    async getActiveResult (params) {
      try {
        const { result } = await getActiveResult(params)
        this.activeTrend = result || null
        this.$nextTick(() => this.drawLine(this.activeTrend))
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../mixin.less');
</style>